import { useState, useEffect, useCallback, useRef } from 'react';

let showToastFn = null;

export function triggerToast(message, duration = 3500) {
  if (showToastFn) showToastFn(message, duration);
}

export default function Toast() {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState('');
  const timerRef = useRef(null);

  const show = useCallback((message, duration = 3500) => {
    // Clear any pending hide timer to prevent premature dismissal
    if (timerRef.current) clearTimeout(timerRef.current);
    setText(message);
    setVisible(true);
    timerRef.current = setTimeout(() => setVisible(false), duration);
  }, []);

  useEffect(() => {
    showToastFn = show;
    return () => {
      showToastFn = null;
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [show]);

  return (
    <div className={`toast ${visible ? 'show' : ''}`}>
      {text}
    </div>
  );
}
